import "./main-heading.scss";

interface MainHeadingProps {
  children?: React.ReactNode;
  headerText: string;
  subHeaderText: React.ReactNode;
  headerContainerClass?: string;
  id?: string;
  apidocumentIcon?: boolean;
  subheaderTextClass?: string;
}

const MainHeading = ({
  children,
  headerText,
  subHeaderText,
  headerContainerClass = "header-text-container",
  id = "mainheading",
  subheaderTextClass,
}: MainHeadingProps) => {
  return (
    <div
      className="d-flex flex-direction-dynamic align-items-start justify-content-between mt-3 mb-1"
      id={id}
    >
      <div className={headerContainerClass}>
        <h1 className="main-heading">{headerText}</h1>
        <h6 className={`sub-title ${subheaderTextClass}`}>{subHeaderText}</h6>
      </div>
      {children && children}
    </div>
  );
};

export default MainHeading;
